import { useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useCheckRegistration = () => {
  const prefix = process.env.REACT_APP_PUBLIC_PREFIX || '';
  
  return useMutation({
    mutationFn: async (email) => {
      const result = await restClient({
        url: `${prefix}/public/auth/check-registration`,
        method: 'get',
        params: { email }
      });
      return result;
    }
  });
};